var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.95,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.404 56c15.464 0 28-12.536 28-28s-12.536-28-28-28-28 12.536-28 28 12.536 28 28 28z",
    fill: "#F6F0FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.805 20.103a1.21 1.21 0 011.85-1.026l12.508 7.818a1.21 1.21 0 010 2.051l-12.508 7.818a1.21 1.21 0 01-1.85-1.026V20.103z",
    fill: "#1d1b84"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default "/_next/static/images/41f818508b1c67b8bf13dd38736d501a.svg";
export { ForwardRef as ReactComponent };